import PropTypes from 'prop-types'
import React from 'react'
import { InputField } from 'components'
import { Form, Formik } from 'formik'
import { SHIPMENT_STATUS } from 'domains/customer-order/constants'
import { LoaderButton } from 'components/molecules'

const propTypes = {
  shipment     : PropTypes.object,
  buttonText   : PropTypes.string,
  isSubmitting : PropTypes.bool,
  handleSubmit : PropTypes.func.isRequired
}

/**
 * @param {Function} handleSubmit
 */
const CustomerOrderScanSkuForm = ({
  shipment,
  buttonText,
  isSubmitting=false,
  handleSubmit
}) => {
  if (shipment.status !== SHIPMENT_STATUS.PENDING) return null

  const formatSkuInput = (value) => value.trim()

  return (
    <>
      <Formik
        initialValues={{ sku: '' }}
        onSubmit={ handleSubmit }
      >
        <Form className='d-flex justify-content-start align-items-end'>
          <InputField
            formGroupClassName='mb-0 mr-2'
            type='text'
            name='sku'
            placeholder='Scan SKU here'
            required={ true }
            formatValue={ formatSkuInput }
          />
          <LoaderButton
            color='success'
            type='submit'
            disabled={ isSubmitting }
            isLoading={ isSubmitting }
            text={ buttonText }
          />
        </Form>
      </Formik>

    </>
  )
}
CustomerOrderScanSkuForm.propTypes = propTypes

export default CustomerOrderScanSkuForm